import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash/fp';
import { NOT_AUTHORIZED_TO_SLACK, SLACK_NOT_CONFIGURED } from 'app/store/__generated__/errors';

const selectSlice = get('integrations.slack');

export const selectSlackConfig = createSelector(selectSlice, get('config'));
export const selectIsLoading = createSelector(selectSlice, get('isLoading'));
export const selectResponseName = createSelector(selectSlice, get('responseName'));
export const selectSlackChannels = createSelector(selectSlice, get('channels'));
export const selectError = createSelector(selectSlice, get('error'));
export const selectEventSubscription = createSelector(selectSlice, get('eventSubscription'));

export const selectIsSlackConfigured = createSelector(
    selectResponseName,
    (resp) => resp && resp !== SLACK_NOT_CONFIGURED && resp !== NOT_AUTHORIZED_TO_SLACK
);
